import {
  NftActivities,
  ActivityConfigType,
} from "../Nft/NftActivityDescription/types";

export enum ActivityFilterOptionValue {
  All = "all",
  Listings = "listings",
  Sales = "sales",
  Transfers = "transfers",
  Offers = "offers",
}

export interface ActivityFilterOption {
  value: ActivityFilterOptionValue;
  label: string;
  types: NftActivities[];
}

export const ACTIVITY_FILTER_OPTIONS: ActivityFilterOption[] = [
  {
    value: ActivityFilterOptionValue.All,
    label: "All activity",
    types: [
      NftActivities.AUCTION_CREATE,
      NftActivities.AUCTION_DUTCH_CREATE,
      NftActivities.AUCTION_SUCCESS,
      NftActivities.OFFER_ACCEPT,
      NftActivities.MINT,
      NftActivities.BURN,
      NftActivities.TRANSFER,
      NftActivities.OFFER_CREATE,
      NftActivities.COLLECTION_OFFER_CREATE,
    ],
  },
  {
    value: ActivityFilterOptionValue.Listings,
    label: "Listings",
    types: [NftActivities.AUCTION_CREATE, NftActivities.AUCTION_DUTCH_CREATE],
  },
  {
    value: ActivityFilterOptionValue.Sales,
    label: "Sales",
    types: [NftActivities.AUCTION_SUCCESS, NftActivities.OFFER_ACCEPT],
  },
  {
    value: ActivityFilterOptionValue.Transfers,
    label: "Transfers",
    types: [NftActivities.MINT, NftActivities.BURN, NftActivities.TRANSFER],
  },
  {
    value: ActivityFilterOptionValue.Offers,
    label: "Offers",
    types: [NftActivities.OFFER_CREATE, NftActivities.COLLECTION_OFFER_CREATE],
  },
];

export const COLLECTION_ACTIVITY_FILTER_OPTIONS = ACTIVITY_FILTER_OPTIONS.map(
  (option) => {
    switch (option.value) {
      case ActivityFilterOptionValue.All:
      case ActivityFilterOptionValue.Offers:
        return {
          ...option,
          types: [...option.types, NftActivities.COLLECTION_OFFER_CANCEL],
        };
      default:
        return option;
    }
  },
);

export const activityConfig: ActivityConfigType = {
  [NftActivities.MINT]: {
    text: "Minted by ${0}",
    args: ["initiator"],
  },
  [NftActivities.BURN]: {
    text: "Burned by ${0}",
    args: ["initiator"],
  },
  [NftActivities.TRANSFER]: {
    text: "Transfer from ${0} to ${1}",
    args: ["from", "to"],
  },
  [NftActivities.AUCTION_CREATE]: {
    text: "Listed by ${0} for ${1} ${2}",
    args: ["from", "price", "paymentLabel"],
  },
  [NftActivities.AUCTION_DUTCH_CREATE]: {
    text: "${0} started dutch auction with price ${1} ${2}",
    args: ["from", "price", "paymentLabel"],
  },
  [NftActivities.AUCTION_SUCCESS]: {
    text: "Purchased by ${0} from ${1} for ${2} ${3}",
    args: ["to", "from", "price", "paymentLabel"],
  },
  [NftActivities.AUCTION_CANCEL]: {
    text: "Removed from sale by ${0}",
    args: ["from"],
  },
  [NftActivities.AUCTION_RESERVE]: {
    text: "Bid placed for ${0} ${1}",
    args: ["price", "paymentLabel"],
  },
  [NftActivities.OFFER_CREATE]: {
    text: "Offer made by ${0} for ${1} ${2}",
    args: ["from", "price", "paymentLabel"],
  },
  [NftActivities.OFFER_ACCEPT]: {
    text: "Offer accepted by ${0} for ${1} ${2}",
    args: ["from", "price", "paymentLabel"],
  },
  [NftActivities.OFFER_CANCEL]: {
    text: "Offer canceled by ${0}",
    args: ["from"],
  },
  [NftActivities.COLLECTION_OFFER_CREATE]: {
    text: "Collection offer made by ${0} for ${1} ${2}",
    args: ["from", "price", "paymentLabel"],
  },
  [NftActivities.COLLECTION_OFFER_CANCEL]: {
    text: "Collection offer canceled by ${0}",
    args: ["initiator"],
  },
  [NftActivities.PRIVATE_AUCTION_SUCCESS]: {
    text: "Private purchased by ${0} from ${1} for ${2}",
    args: ["to", "from", "price"],
  },
};
